import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface AllToolLabelsResponse {
  success: boolean;
  available_tool_label_names: string[];
}

export const useAllToolLabels = (workspaceId: number | null) => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";

  return useQuery({
    queryKey: ["available-tool-labels", workspaceId],
    queryFn: async (): Promise<AllToolLabelsResponse> => {
      if (!workspaceId) {
        throw new Error("Missing workspace ID");
      }
      const url = new URL(ENDPOINTS.available_tool_labels);
      url.searchParams.set("workspace_id", workspaceId.toString());
      const res = await fetch(url.toString(), {
        headers: jsonAuthHeaders(userToken),
      });
      return handleResponse(res);
    },
    enabled: !!workspaceId && !!userToken,
  });
};
